import { Button } from '@/shared/components/Button';
import { Drawer } from '@/shared/components/Drawer';
import { VStack } from '@/shared/components/Stack';
import { Typography } from '@/shared/components/Typography';
import styles from './OutOfStockModal.module.css';

type OutOfStockModalProps = {
    open: boolean;
    onCreateOrder?: VoidFunction;
    onClose: VoidFunction;
};

export const OutOfStockModal = ({ open, onCreateOrder, onClose }: OutOfStockModalProps) => (
    <Drawer open={open} onClose={onClose}>
        <VStack gap="300" className={styles.content}>
            <VStack gap="100" alignItems="center">
                <Typography as="h3" size="3xl" weight="bold" className={styles.text}>
                    Количество товаров изменилось
                </Typography>
                <Typography className={styles.text}>
                    {`Количество товаров было автоматически скорректировано
                                    из-за изменений на складе. Пожалуйста, проверьте корзину перед оплатой`}
                </Typography>
            </VStack>
            <div className={styles.controls}>
                <Button className={styles.button} onClick={onClose}>
                    Проверить корзину
                </Button>
                <Button className={styles.button} color="secondary" onClick={onCreateOrder}>
                    Перейти к оформлению
                </Button>
            </div>
        </VStack>
    </Drawer>
);
